<p-dialog [(visible)]="orderItem" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }" (onHide)="closeDialogEmitter.emit(true)">
	<div class="d-flex kiosk-item justify-content-between">
		<img
			*ngIf="canvasMenuItem.ooMenuItem?.imageKey"
			width="100%"
			height="auto"
			[src]="
				'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' +
				kioskService.venueService.venueKey +
				'/' +
				canvasMenuItem.ooMenuItem?.imageKey
			"
		/>
		<img
			*ngIf="!(canvasMenuItem.ooMenuItem?.kioskImageKey || canvasMenuItem.ooMenuItem?.imageKey)"
			width="100%"
			height="auto"
			[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + kioskService.venueService.venueKey + '/default.png?' + timestamp"
		/>
		<div class="d-flex flex-column">
			<div class="item-name">
				{{ canvasMenuItem.displayName || canvasMenuItem.ooMenuItem.name }}
			</div>
			<div class="item-price">
				{{ itemDisplayPrice | currency }}
			</div>
		</div>
	</div>
	<div class="kiosk-item-description w-100">
		{{ canvasMenuItem.description }}
	</div>
	<ng-container *ngFor="let incMod of canvasMenuItem.includedItemCanvases">
		<div class="d-flex">
			<div class="display-12">{{ incMod.displayName }}</div>
		</div>
		<div class="text-center display-14">
			<i>{{ incMod.description }}</i>
		</div>
		<div *ngFor="let item of incMod.menuItems">
			<div class="p-grid">
				<div class="p-col-5 d-flex">
					<div class="my-auto">
						{{ item.displayName || item.ooMenuItem.name }}
					</div>
				</div>
				<div class="p-col-7 d-flex justify-content-end">
					<p-selectButton
						[options]="item.includedModifierSelectOptions"
						styleClass="w-100"
						[(ngModel)]="item.includedModifierSelectedDefault"
						optionLabel="name"
						(onChange)="calculateItem($event.value)"
					>
						<ng-template let-item>
							<div class="d-flex flex-column">
								<div class="">
									<i>{{ item.name }} </i>
								</div>
								<div class="fc-font-size-xs">
									<span *ngIf="kioskService.venueService.menuItemGetPriceFromNumber(item.canvasMenuItem.ooMenuItem, item.value) < 0">
										<i>
											-
											{{ kioskService.venueService.menuItemGetPriceFromNumber(item.canvasMenuItem.ooMenuItem, item.value) }}
										</i>
									</span>
									<span *ngIf="kioskService.venueService.menuItemGetPriceFromNumber(item.canvasMenuItem.ooMenuItem, item.value) > 0">
										<i>
											+
											{{ kioskService.venueService.menuItemGetPriceFromNumber(item.canvasMenuItem.ooMenuItem, item.value) }}
										</i>
									</span>
									<span *ngIf="kioskService.venueService.menuItemGetPriceFromNumber(item.canvasMenuItem.ooMenuItem, item.value) === 0"
										>&nbsp;</span
									>
								</div>
							</div>
						</ng-template>
					</p-selectButton>
				</div>
			</div>
		</div>
	</ng-container>

	<ng-container *ngFor="let item of canvasMenuItem.modifierCanvases">
		<div class="d-flex">
			<p-checkbox
				name="item{{ item.menuItemKey }}"
				binary="true"
				[(ngModel)]="modifierSelectionModifiersSelected"
				(onChange)="selectModifierOption($event)"
				[label]="item.displayName || item.ooMenuItem.name"
			></p-checkbox>
		</div>
	</ng-container>

	<div class="d-flex flex-fill w-100">
		<button
			pButton
			pRipple
			class="p-button-raised p-button-success w-100"
			(click)="kioskService.kioskOrderAddItem(orderItem); closeDialogEmitter.emit(true)"
		>
			<div class="d-flex mx-auto">
				<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1 me-2"></fa-icon>
				Add to Order
			</div>
		</button>
	</div>
</p-dialog>
